import React from "react";

const Loder = () => {
  return (
    <div className="loader-container">
      <span className="loader-15"></span>
    </div>
  );
};

export default Loder;
